<template>
  <v-dialog v-model="config.status.active" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" color="secondary">
        <v-icon small>fal fa-search</v-icon>&nbsp;検索登録
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="secondary"><span class="headline">保護者の新規登録</span></v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid">
            <v-layout wrap>
              <v-flex xs10>
                <v-text-field label="ふりがな or 名前"
                  v-model="form.primary"
                  @keypress.enter="search"></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn fab small color="blue darken-2 white--text"
                  :disabled="!isSearchable"
                  :loading="isSearching"
                  @click="search"><font-awesome-icon :icon="['fal', 'search']"></font-awesome-icon></v-btn>
              </v-flex>
              <v-flex xs12>
                <v-select v-show="getGuardianItems.length" required
                  v-model="form.gid"
                  item-text="name"
                  item-value="id"
                  :items="getGuardianItems"
                  :rules="rules.gid"
                  label="検索結果から保護者を選ぶ"></v-select>
              </v-flex>
              <v-flex xs12>
                <v-combobox v-show="getGuardianItems.length" required
                  v-model="form.relation"
                  :items="meta.relations"
                  :rules="rules.relation"
                  label="続柄"></v-combobox>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="close" color="secondary">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" :disabled="!isValid" :loading="isLoading" @click="submit">登録する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'clientAboutGuardiansModalSearch',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        }
      },
      meta: {
        relations: [
          '父',
          '母',
          '祖父',
          '祖母',
          '夫',
          '妻',
          'おじ',
          'おば',
          '息子',
          '娘',
          '孫',
          '兄',
          '姉',
          '弟',
          '妹'
        ]
      },
      form: {
        valid: true,
        primary: '',
        gid: '',
        relation: ''
      },
      rules: {
        gid: [
          v => !!v || '必須項目です'
        ],
        relation: [
          v => !!v || '必須項目です'
        ]
      },
      store: {
        guardians: []
      }
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
    init: function () {
      this.prepare()
    },
    prepare: function () {
      this.$set(this, 'form', {
        valid: true,
        primary: '',
        gid: '',
        relation: ''
      })
    },
    search: function () {
      if (this.form.primary.trim() !== '') {
        this.$set(this.config.status, 'searching', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'about/search/guardians', {
            primary: this.form.primary.trim(),
            cid: this.$route.params.id
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'searching', false)
            if (res.data && res.data.success) {
              this.$set(this.store, 'guardians', res.data.data)
              this.$set(this.form, 'cid', '')
            }
          })
        })
      }
    },
    select: function (id) {
      this.$set(this.form.id, 'value', id)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        let fd = {
          cid: this.$route.params.id,
          gid: this.form.gid,
          relation: this.form.relation
        }
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'about/link/guardian', fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'insert',
                data: res.data.data
              })
              this.close()
            }
          })
        })
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    isSubmittable () {
      return Object.keys(this.form).filter(key => {
        return (this.form[key].required && this.form[key].value === '')
      }).length === 0
    },
    isSearchable () {
      return this.form.primary.trim() !== ''
    },
    getRelationItems () {
      return this.meta.relations
    },
    isGuardianEmpty () {
      return this.store.guardians.length === 0
    },
    getGuardianItems () {
      return (this.store.guardians && this.store.guardians.length) ? this.store.guardians.map(it => {
        return {
          id: it.id ? it.id : '',
          name: it.name ? it.name.join(' ') : ''
        }
      }) : []
    }
  }
}
</script>
